module.exports = __webpack_public_path__ + "img/rules__destroy.52e62a9f.png";